import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
const Indulnd = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  // const currentCards = CreditCardData.cards
  //   ?.filter((card) => card.category === "Credit card")
  //   .slice(indexOfFirstCard, indexOfLastCard);
  // console.log({ currentCards });
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("indusind"))
    .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
      question: "Which is the best IndusInd credit card for rewards?",
      answer:
        " The IndusInd Legend Credit Card and IndusInd Pinnacle Credit Card offer accelerated rewards on travel, dining, and online shopping with flexible redemption options.",
    },
    {
      question: "Does IndusInd offer lifetime free credit cards?",
      answer:
        " Yes, IndusInd is one of the few banks that offers lifetime free credit cards like the IndusInd Platinum Card with no annual or joining fees.",
    },
    {
      question: "Can I get international lounge access with IndusInd cards?",
      answer:
        "  Select premium cards like the IndusInd Signature Legend come with international and domestic lounge access via Mastercard/Visa Lounge programs.",
    },
    {
      question: "Are there fuel and movie benefits on IndusInd cards?",
      answer:
        "  Yes, many IndusInd cards offer fuel surcharge waivers and 1+1 movie ticket offers on platforms like BookMyShow, along with monthly caps.",
    },
    {
      question: "What is the usual time for card approval?",
      answer:
        " IndusInd typically takes 5–7 working days to process your application. Post-approval, the credit card is dispatched within 7–10 business days.",
    },
  ];

  const steps = [
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Check Eligibility Beforehand",
      description:
        "  Carefully assess income requirements, age criteria, and credit score norms before applying. This helps in reducing the chances of rejection.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
      title: "Prepare Your Documents",
      description:
        "Have all necessary documents—ID proof, address proof, income proof, and PAN—ready in digital or physical form for faster application processing.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Apply via IndusInd Bank Portal",
      description:
        " Once you’ve finalized your card, click “Apply Now” to be redirected to the official IndusInd Bank application portal, where you can securely submit your details.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "Visit TheFinMaster to browse our curated collection of IndusInd Bank credit cards. Our listings provide in-depth card features, benefits, eligibility details, and reward structures—helping you find a card aligned with your spending style.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Get IndusInd bank Credit Card Online | Get Rewards, Benefits & More |
          TheFinmaster
        </title>
        <meta
          name="description"
          content="Get to Know about the features, benefits, and rewards for IndusInd bank Credit Cards online. Apply For IndusInd bank Credit Card and get Instant approval | Thefinmaster"
        />
        <meta
          name="keywords"
          content="indusind bank lifetime free credit card, indusind bank platinum credit card, indusind eazydiner credit card, indusind next credit card, pinnacle credit card indusind"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/induslnd-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 mt-10">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              Explore Versatile, Reward-Rich & Lifestyle-Driven IndusInd Bank
              Credit Cards{" "}
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              IndusInd Bank offers a wide range of credit cards designed for
              every lifestyle—be it luxury travel, fuel savings, or accelerated
              rewards. With features like lifetime free cards, international
              lounge access, 1+1 movie offers, and 24x7 concierge services,
              IndusInd credit cards combine premium perks with practical
              benefits, making them a favorite among modern users across India.
            </p>
          </div>
        </div>
        <h1 className="text-center text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

           <div className="w-full relative ">
                                      <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                                        {/* <div className="w-[70%] mx-auto">
                                                                   <h2 className="text-center font-medium pt-5 text-lg">
                                                                     <span className="font-semibold text-white">816 people</span>{" "}
                                                                     are on call with our advisors right now
                                                                   </h2>
                                                                 </div> */}
                                        <div className="w-full mx-auto">
                                          <Link
                                            to="https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <div className="w-[80%] mx-auto ">
                                              <img src="/assets/new.png" alt="Advertisement" />
                                            </div>
                                          </Link>
                                          <div className="bg-white">
                                            {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                                       Know your advisor
                                                                     </h3> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        {/* <div className='w-[95%] py-10'>
                                         <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                                         <AccordionComponent />
                                     </div> */}

        <div className="w-full px-2 py-10 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for IndusInd Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Requirement
                  </span>
                  <span>
                    {" "}
                    You must be between 21 and 60 years of age to apply. Add-on
                    card applicants should be at least 18 years old.{" "}
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income Criteria
                  </span>
                  <span>
                    {" "}
                    The minimum monthly income required is usually ₹30,000 or
                    more, depending on the card type. Higher-tier cards may
                    require ₹75,000+ monthly income.{" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score
                  </span>
                  <span>
                    {" "}
                    A CIBIL score of 700 or above is preferred. A clean
                    repayment history improves the likelihood of approval,
                    especially for lifetime free cards.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Occupation Type
                  </span>
                  <span>
                    {" "}
                    Both salaried employees and self-employed individuals are
                    eligible. Self-employed applicants must have a stable income
                    and proper documentation.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Location-Based Eligibility
                  </span>
                  <span>
                    {" "}
                    IndusInd credit cards are issued in most major cities and
                    expanding to smaller towns. Make sure your PIN code is
                    serviceable before proceeding.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for IndusInd Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Identity Proof
                  </span>
                  <span>
                    {" "}
                    Valid ID proofs like PAN Card, Passport, Aadhaar, or Voter
                    ID are required for verification and KYC compliance.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Address Proof
                  </span>
                  <span>
                    {" "}
                    Submit utility bills, Aadhaar card, bank statements, or
                    passport for residential address confirmation.{" "}
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Proof
                  </span>
                  <span>
                    {" "}
                    Salaried: Latest salary slips (last 3 months) and bank
                    statement (last 6 months). Self-employed: Latest ITR with
                    computation, business proof, and bank statements are
                    required.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Photograph
                  </span>
                  <span>
                    {" "}
                    Recent passport-size color photo is needed for offline
                    application and KYC documentation.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Permanent Account Number (PAN)
                  </span>
                  <span>
                    {" "}
                    Submission of PAN is compulsory as per RBI norms for
                    financial evaluation and account linkage.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for IndusInd Bank Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
                                   Applying for a fuel credit card is a seamless process that starts with
                                   the right research and ends at the official bank’s platform for final
                                   submission. Here’s how you can get started through TheFinMaster.com:
                                 </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Indulnd;
